export default __webpack_public_path__ + "static/media/rnr-sports-table-2-cn.d3dcc6f0.webp";